"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderNavigation = void 0;
var react_1 = __importDefault(require("react"));
var HeaderNavigation_module_scss_1 = __importDefault(require("./HeaderNavigation.module.scss"));
var HeaderNavigationMobile_1 = require("../headerNavigationMobule/HeaderNavigationMobile");
var react_router_dom_1 = require("react-router-dom");
var selectors_1 = require("../../redux/selectors");
var react_redux_1 = require("react-redux");
var HeaderNavigation = function () {
    var menu = (0, react_redux_1.useSelector)(selectors_1.modalSelector).burgerMenu.menuNavigation;
    return (react_1.default.createElement("nav", { className: HeaderNavigation_module_scss_1.default.header_nav },
        react_1.default.createElement("ul", { className: HeaderNavigation_module_scss_1.default.header_nav__list }, menu.map(function (_a) {
            var name = _a.name, link = _a.link;
            return (react_1.default.createElement("li", { className: HeaderNavigation_module_scss_1.default.header_nav__item, key: name },
                react_1.default.createElement(react_router_dom_1.NavLink, { className: function (_a) {
                        var isActive = _a.isActive;
                        return isActive
                            ? "".concat(HeaderNavigation_module_scss_1.default.header_nav__link, " ").concat(HeaderNavigation_module_scss_1.default.header_nav__link_active)
                            : HeaderNavigation_module_scss_1.default.header_nav__link;
                    }, to: link }, name)));
        })),
        react_1.default.createElement(HeaderNavigationMobile_1.HeaderNavigationMobile, null)));
};
exports.HeaderNavigation = HeaderNavigation;
